import { parseDataToDate } from './parse-data-to-date.js';
import { escapeForCSV } from '../../../core/utils/download.js';

export const sanitizeAndParseData = (value: unknown) => {
  const escapedValue = escapeForCSV(value);
  return parseDataToDate(escapedValue);
};
